import $ from 'jquery';

//用户激活自动播放
let userFocus = false;
function autoPlayMusic(music) {
  if (userFocus) return;
  userFocus = true;
  music.play();
  /* 触摸播放音乐效果，解决浏览器自动播放问题 */
  function musicInBrowserHandler() {
    if (music.paused) {
      music.play();
    }
    document.removeEventListener('toucnend', musicInBrowserHandler);
  }
  document.addEventListener('touchend', musicInBrowserHandler);
}

const defaultParams = {
  autoplay: 0,
  loop: 0,
  volume:1,
  src: '',
  id: '',
};

class Music {
  constructor(props) {
    const { wrapper, ...params } = props;
    this.wrapper = wrapper;
    this.params = {
      ...defaultParams,
      ...params,
    };
    this._init();
    this._hiddenFn();
  }

  _init() {
    const params = this.params;
    // if (!params.src) return;
    if (this.$music) {
      this.$music.attr('src', params.src);
      this.$music.get(0).loop = params.loop ? true : false;
      this.$music.get(0).autoplay = params.autoplay ? true : false;
      this.$music.get(0).volume = params.volume;
    } else {

      this.$music = $(
        `<audio 
        id="${params.id}"
        src="${params.src}" 
        ${params.loop ? 'loop' : ''} 
        ${params.autoplay ? 'autoplay' : ''} 
        />`,
      );
      
      $(this.wrapper).append(this.$music);
    }

    this.$music.get(0).volume = params.volume;
    if (params.autoplay) {
      this.play();
      // this.paused = false;
      // this.$music.get(0).play();
      // autoPlayMusic(this.$music.get(0));
    } else {
      this.paused = true;
    }
  }
  _hiddenFn() {
    var hiddenProperty =
      'hidden' in document
        ? 'hidden'
        : 'webkitHidden' in document
        ? 'webkitHidden'
        : 'mozHidden' in document
        ? 'mozHidden'
        : null;
    var visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
    document.addEventListener(visibilityChangeEvent, () => {
      if (document[hiddenProperty]) {
        this.$music.get(0).pause();
      } else {
        if (!this.paused) {
          this.$music.get(0).play();
        }
      }
    });
  }
  play() {
    this.$music.get(0).load();
    this.$music.get(0).play();
    this.paused = false;
  }
  pause() {
    this.$music.get(0).pause();
    this.paused = true;
  }

  changeLoop(value) {
    if (value) {
      this.$music.attr('loop', 'loop');
    } else {
      this.$music.removeAttr('loop');
    }
  }
  changeVolume(value) {
    if (value) {
      this.$music.get(0).volume = value;
    } else {
      this.$music.removeAttr('volume');
    }
  }
  changeAutoplay(value) {
    if (value) {
      this.$music.attr('autoplay', 'autoplay');
    } else {
      this.$music.removeAttr('autoplay');
    }
  }
  toggle() {
    const music = this.$music.get(0);
    if (music.paused) {
      music.play();
    } else {
      music.pause();
    }
  }
  remove() {
    this.$music.remove();
  }

  change(data) {
    // if (!data || !data.src) {
    //   this.$music.remove();
    //   return;
    // }
    this.params = {
      ...this.params,
      ...data,
    };
    this._init();
  }
}

export default Music;
